import { helpers, hooks, mui, React, ts, ui, useSelector } from '_core';

type SignalReturnHorizonProps = {
  rh: ts.types.returnHorizon.ReturnHorizon;
  setRh: (_value: ts.types.returnHorizon.ReturnHorizon) => void;
  remove?: () => void;
};

const SignalReturnHorizon = ({ rh, setRh, remove }: SignalReturnHorizonProps) => {
  const [signalId, setSignalId] = React.useState(rh.signal_id);
  const [pipelineIds, setPipelineIds] = React.useState(rh.pipeline_ids || []);
  const resources = useSelector((state: ts.StoreState) => state.resources);

  const getLocalSignature = (signalId: number, pipelineIds: number[]) => {
    const signalNames = helpers.resourcesSearch
      .search(`type:${ts.enums.RESOURCES_TYPES_ENUM.SIGNAL}`, resources, 'research', null, false, false, true)
      .filter((r) => r.id == signalId)
      .map((r) => r.name);

    let label = signalNames.length > 0 ? signalNames[0] : 'Returns signal';
    if (pipelineIds && pipelineIds.length > 0) {
      const pipelineNames = helpers.resourcesSearch
        .search(`type:${ts.enums.RESOURCES_TYPES_ENUM.PIPELINE}`, resources, 'research', null, false, false, true)
        .filter((r) => pipelineIds.indexOf(r.id) > 0)
        .map((r) => r.name);
      label += ` => ${pipelineNames.join(' => ')}`;
    }
    return label;
  };

  hooks.useEffectWithoutFirst(() => {
    const rhPeriods: ts.types.returnHorizon.FrequencyAmount = {
      amount: 1,
      frequency: ts.enums.FREQUENCY_ENUM.DAILY,
    };

    const returnHorizon: ts.types.returnHorizon.ReturnHorizon = {
      periods: rhPeriods,
      signal_id: signalId,
      pipeline_ids: pipelineIds,
      signature: getLocalSignature(signalId, pipelineIds),
      is_signal: true,
    };

    setRh(returnHorizon);
  }, [signalId, pipelineIds]);

  return (
    <mui.core.Box>
      <mui.core.Grid container spacing={2}>
        <mui.core.Grid size={{ xs: 5 }}>
          <ui.ResourceAutocomplete<ts.types.signal.SignalExpanded>
            value={signalId}
            setValue={setSignalId}
            type={ts.enums.RESOURCES_TYPES_ENUM.SIGNAL}
            inputProps={{
              fullWidth: true,
              label: 'Return Signal',
              variant: 'outlined',
              size: 'small',
            }}
          />
        </mui.core.Grid>
        <mui.core.Grid size={{ xs: 5 }}>
          <ui.ResourceAutocomplete<ts.types.pipeline.PipelineExpanded, true, false>
            value={pipelineIds || []}
            setValue={setPipelineIds}
            type={ts.enums.RESOURCES_TYPES_ENUM.PIPELINE}
            autocompleteProps={{
              limitTags: 2,
              multiple: true,
              size: 'small',
            }}
            inputProps={{
              fullWidth: true,
              label: 'Return Signal Pipelines',
              variant: 'outlined',
              size: 'small',
            }}
          />
        </mui.core.Grid>
        {remove && (
          <mui.core.Grid size={{ xs: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
            <mui.core.IconButton onClick={remove} size="small" style={{ opacity: 0.9 }}>
              <mui.icons.Close />
            </mui.core.IconButton>
          </mui.core.Grid>
        )}
      </mui.core.Grid>
    </mui.core.Box>
  );
};

export default SignalReturnHorizon;
